import { Icon } from '@iconify/react'
import { useEffect } from 'react'
import { Button } from '../../../components/ui/legacy'
import { useNav } from '../../../hooks/useNav'
import { PATH } from '../../../data/router_path'

function LoginSuccess() {
  const customNavigate = useNav()

  const redirectHandler = () => {
    customNavigate(PATH.HOME)
  }
  useEffect(() => {
    setTimeout(redirectHandler, 2000)
  }, [])
  return (
    <>
      <p className="flex flex-col gap-2 text-center text-lg font-semibold leading-relaxed sm:text-2xl">
        <span>Đăng nhập thành công</span>
        <span>Đang chuyển hướng về ứng dụng</span>
      </p>
      <Button
        variant={'primary'}
        onClickHandler={redirectHandler}
        className="gap-2 font-semibold sm:text-lg"
        rounded="lg"
        size="py-3 px-6"
      >
        <Icon icon="ph:arrow-bend-up-left-bold" className="text-3xl" />
        Chuyển hướng
      </Button>
    </>
  )
}

export default LoginSuccess
